import {UntilDestroy} from "@ngneat/until-destroy";
import {Component, Inject, OnInit} from "@angular/core";
import {WorkbenchViewComponent} from "../../../shared/components/viewcontainers/workbench-view.component";
import {ExpeditionId} from "@webmate-web-core/shared/types/ids";
import {WORKBENCH_VIEW_CONFIG, WorkbenchViewConfig} from '../../../shared/types';
import {faExclamationCircle, faQuestionCircle} from "@fortawesome/pro-solid-svg-icons";
import {WorkbenchExpeditionService} from "../../../shared/services/workbench-expedition.service";
import {WorkbenchLayoutManager} from "../../../shared/services/workbench-layout-manager.service";
import {WorkbenchAnnotationService} from '../../../shared/services/workbench-annotation.service';
import {WorkbenchKeyValStore} from '../../../shared/services/workbench-store.service';
import {WorkbenchContextService} from '../../../shared/services/workbench-context.service';

@UntilDestroy()
@Component({
    templateUrl: './a11y-interactive-page-tools-view.component.html',
    styleUrls: ['./a11y-interactive-page-tools-view.component.less'],
})
export class A11yInteractivePageToolsViewComponent extends WorkbenchViewComponent implements OnInit {

    activeExpeditionId?: ExpeditionId;

    getScriptWithName(scriptName: string, enable: boolean) {
        // TODO: that bookmarklet code of https://github.com/oaa-tools/bookmarklets should be
        //   rewritten. Its API is a bit weird.

        return `if (window.a11y${scriptName}) {
        window.a11y${scriptName}.show = ${!enable};
        window.a11y${scriptName}.run();
      } else if (${enable}) {
       (function(){
         var link=document.createElement('link');
         link.rel='stylesheet';
         link.type='text/css';
         link.href='https://accessibility-bookmarklets.org/build/styles.css';
         document.getElementsByTagName('head')[0].appendChild(link);
         var script=document.createElement('script');
         script.type='text/javascript';
         script.src='https://accessibility-bookmarklets.org/build/${scriptName.toLowerCase()}.js';
         document.getElementsByTagName('head')[0].appendChild(script);}
         )();}
    `;
    }

    tools = [
        { label: 'Headings', tooltip: 'Show headings structure', enabled: false },
        { label: 'Landmarks', tooltip: 'Show landmarks structure', enabled: false },
        { label: 'Images', tooltip: 'Show images structure', enabled: false },
        { label: 'Tables', tooltip: 'Show tables structure', enabled: false },
        { label: 'Forms', tooltip: 'Show forms structure', enabled: false }
    ];


    constructor(@Inject(WORKBENCH_VIEW_CONFIG) public config: WorkbenchViewConfig<any>,
                public store: WorkbenchKeyValStore, public layoutManager: WorkbenchLayoutManager,
                private workbenchExpeditionService: WorkbenchExpeditionService,
                private workbenchContextService: WorkbenchContextService,
                private annotationStateService: WorkbenchAnnotationService) {
        super(layoutManager, config);
    }

    ngOnInit(): void {
        this.workbenchContextService.subscribeWorkbenchContext$().subscribe(context => {
            if (this.activeExpeditionId !== context.expeditionContext?.activeExpedition?.id) {
                this.activeExpeditionId = context.expeditionContext?.activeExpedition?.id;
                // Attach-to-current: a newly active session has no overlays applied, so reset the
                // toggles to reflect that session's state rather than carrying over stale toggles.
                this.tools.forEach(tool => tool.enabled = false);
            }});
        this.annotationStateService.annotationsEnabled$.subscribe(enabled => {
            if (!enabled) {
                this.tools.forEach(tool => {
                    tool.enabled = false;
                });
            }
        });
    }

    setScriptExecution(scriptName: string, enabled: boolean) {
        this.executeScript(scriptName, enabled);
    }


    executeScript(scriptName: string, enabled: boolean) {
        this.workbenchExpeditionService.sendCDPCommand('Runtime.evaluate', {expression: this.getScriptWithName(scriptName, enabled)}).subscribe({
            next: res => {
            },
            error: err => {
                console.error('Error while highlighting element', err);
            }
        });
    }

    protected readonly faQuestionCircle = faQuestionCircle;
    protected readonly faExclamationCircle = faExclamationCircle;
}
